module.exports = __webpack_public_path__ + "static/media/hot31.99719e6a.jpg";